module.exports = __webpack_public_path__ + "img/16.654534d0.jpg";